export default __webpack_public_path__ + "static/media/2101.2a6e36bd.png";